import React from "react";

export default function ScarcityMessage(props) {
  // PROPS COMING FROM ProductScreen,ShippingMessageCreateForm
  const { product } = props;

  return (
    <>
      {product.scarcityMessage && (
        <>
          <h3 className="fs1125 txtcenter marupsideq">
            {product.scarcityMessage.title}
          </h3>
          <p className="fs1 lh1-25 padq marupsideq">
            {product.scarcityMessage.message}
          </p>
        </>
      )}
    </>
  );
}
